import { styled } from 'styled-components';

export const PopoverContainer = styled.div`
  outline: 2px solid ${({ theme }) => theme.palette.lgreen};
  background-color: ${({ theme }) => theme.palette.white};
  border-radius: ${({ theme }) => theme.spacing(1)};
`;
